<script>
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import Add from './add.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.add2cart) return <Add on={this.$listeners} />;
    if (this.$context.is.edit) return <Edit on={this.$listeners} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.biz2pro || this.$context.is.downgrade) return <BuyNow {...{ props: { ...this.$props }}} on={this.$listeners} />;
    return null;
  },
};
</script>
